<template>
  <div>
    <b-form-file
      v-model="file"
      placeholder="Choose a file or drop it here..."
      drop-placeholder="Drop file here..."
      @change="processFile($event)"
    ></b-form-file>
  </div>
</template>

<script>
import Papa from 'papaparse'

export default {
  data () {
    return {
      blob: null,
      data: null,
      file: null,
      size: null,
      type: null
    }
  },
  methods: {
    processFile (event) {
      this.erreur = ''
      console.log(event)
      this.data = event.target.files[0]
      this.name = event.target.files[0].name
      this.size = event.target.files[0].size
      this.type = event.target.files[0].type
      if (this.size > this.maxFileSize) {
        this.erreur = 'Le poids de votre document doit être inférieur à 5Mo.'
      }
      const reader = new FileReader()
      reader.onload = e => {
        // console.log(atob(e.target.result))
        // console.log('data0', this.data)
        this.data = e.target.result
        let test = Papa.parse(this.data, {
          header: true
        })

        console.log('test', test)
      }
      reader.readAsText(this.data)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Events/Import.vue